<template>
  <div class="d-flex align-items-center" :class="alignmentClass">
    {{ rowData.subscription?.ends_at !== undefined ? formatDateToLocal(rowData.subscription?.ends_at) : '' }}
    <span v-if="(rowData.subscription?.trial_ends_at === rowData.subscription?.ends_at) && rowData.subscription?.trial_ends_at !== undefined" class="badge badge-pill badge-dark text-capitalize ml-2">
      {{ $t('trial') }}
    </span>
  </div>
</template>

<script>
import { formatDateToLocal } from "../../../../../common/Helper/Support/DateTimeHelper";

export default {
  name: "TenantSubscriptionStatus",
  props: {
    rowData: {},
    alignmentClass: {}
  },
  data() {
    return {
      formatDateToLocal,
    }
  },
}
</script>
